import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse, HttpHeaders, HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ApiIntegration } from "../../_services/api.integration";
import { User } from "../../_models/user";
import { Router } from "@angular/router";
import { Globals } from '../../_models/globals';
import { Address } from '../../_models/address';
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-create-driver',
  templateUrl: './create-driver.component.html',
  styleUrls: ['./create-driver.component.css']
})
export class CreateDriverComponent implements OnInit {
  statusText1: string;
  statusText2: string;
  statusText3: string;
  statusText4: string;
  statusText5: string;
  statusText6: string;
  statusText7: string;
  statusText8: string;
  address: Address = {};
  addresses: Address[] = [];
  addressTypes: any[];
  addressType: string;
  driverName: string;
  mobileNumber: string;
  state: string;
  zip: string;
  city: string;
  address1: string;
  email: string;
  statesList: any;
  citiesList: any;

  constructor(private alertService: AlertService, private api: ApiIntegration, private router: Router, private g: Globals, private http: HttpClient, private user: User) {
    this.g.page = "Create Driver";
    this.stateList();
    this.cityList();
    this.api.getValues("1", "ADDRESS_TYPE", "ADDRESS_TYPE", "ADDRESS_TYPE").subscribe((data: any) => {
      this.addressTypes = data.tripleSetConfigDTOS;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  stateList() {
    this.api.getDistinctStates().subscribe((data: any) => {
      this.statesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  cityList() {
    this.api.getDistinctCity().subscribe((data: any) => {
      this.citiesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  changeCityAndState() {
    this.api.getCityAndStateByPinCode(this.address.zip).subscribe((data: any) => {
      this.address.city = data.city;
      this.address.state = data.state;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  ngOnInit() {
  }

  typeDriverName() {
    this.statusText1 = "";
    if (this.driverName == '' || this.driverName === null || this.driverName === undefined || this.driverName === 'undefined') {
      this.statusText1 = 'Please enter driver name';
    }
  }

  validatePhone() {
    this.statusText2 = "";
    if (this.mobileNumber == '' || this.mobileNumber === null || this.mobileNumber === undefined || this.mobileNumber === 'undefined') {
      this.statusText2 = 'Please enter phone number';
    } else if (this.mobileNumber.length != 10) {
      this.statusText2 = 'phone number must be minimum 10 characters';
    }
  }

  validateEmaill() {
    this.statusText3 = "";
    if (this.email == '' || this.email === null || this.email === undefined || this.email === 'undefined') {
      this.statusText3 = 'Please enter email address';
    }
  }

  selectAddressType() {
    this.statusText4 = "";
    if (this.address.addressType == '' || this.address.addressType === null || this.address.addressType === undefined || this.address.addressType === 'undefined') {
      this.statusText4 = 'Please select addressType';
    }
  }

  typeAddress() {
    this.statusText5 = "";
    if (this.address.address1 == '' || this.address.address1 === null || this.address.address1 === undefined || this.address.address1 === 'undefined') {
      this.statusText5 = 'Please enter address 1';
    }
  }

  typeCity() {
    this.statusText6 = "";
    if (this.address.city == '' || this.address.city === null || this.address.city === undefined || this.address.city === 'undefined') {
      this.statusText6 = 'Please enter city';
    }
  }

  typeState() {
    this.statusText7 = "";
    if (this.address.state == '' || this.address.state === null || this.address.state === undefined || this.address.state === 'undefined') {
      this.statusText7 = 'Please enter state';
    }
  }

  zipCode() {
    this.statusText8 = "";
    if (this.address.zip == '' || this.address.zip === null || this.address.zip === undefined || this.address.zip === 'undefined') {
      this.statusText8 = 'Please enter zip';
    }
  }

  validateEmail() {
    this.g.loaderDisplay = "display";
    this.statusText3 = "";
    if (this.email === '') {
      this.statusText3 = 'Please enter email';
    }
    if (this.statusText3 != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/uniqueEmail',
      this.email,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
        } else {
          if (data['code'] == 400) {
            this.statusText3 = data['message'];
          }
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
          this.statusText3 = "uniqueEmail Failed, please re-try.";
        }
      )
  }

  validateMobile() {
    this.g.loaderDisplay = "display";
    this.statusText2 = "";
    if (this.mobileNumber.length === null) {
      this.statusText2 = 'Please enter phone number';
    }
    if (this.statusText2 != "") {
      return false;
    }
    let i = this.mobileNumber.indexOf('0');
    if (i == 0) {
      this.statusText2 = "Number should not start with 0";
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/uniquePhoneNumber',
      this.mobileNumber,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {

        } else {
          if (data['code'] == 400) {
            this.statusText2 = data['message'];
          }
        }

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
          this.statusText2 = "phone number  exists";
        }
      )
  }

  submitDriver() {
    this.g.loaderDisplay = "";
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";
    this.statusText6 = "";
    this.statusText7 = "";
    this.statusText8 = "";

    if (this.driverName == '' || this.driverName === null || this.driverName === undefined || this.driverName === 'undefined') {
      this.statusText1 = 'Please enter driver name';
    }
    if (this.mobileNumber == '' || this.mobileNumber === null || this.mobileNumber === undefined || this.mobileNumber === 'undefined') {
      this.statusText2 = 'Please enter phone number';
    } else if (this.mobileNumber.length != 10) {
      this.statusText2 = 'phone number must be minimum 10 characters';
    }
    if (this.email == '' || this.email === null || this.email === undefined || this.email === 'undefined') {
      this.statusText3 = 'Please enter email address';
    }
    if (this.address.addressType == '' || this.address.addressType === null || this.address.addressType === undefined || this.address.addressType === 'undefined') {
      this.statusText4 = 'Please select addressType';
    }
    if (this.address.address1 == '' || this.address.address1 === null || this.address.address1 === undefined || this.address.address1 === 'undefined') {
      this.statusText5 = 'Please enter address 1';
    }
    if (this.address.city == '' || this.address.city === null || this.address.city === undefined || this.address.city === 'undefined') {
      this.statusText6 = 'Please enter city';
    }
    if (this.address.state == '' || this.address.state === null || this.address.state === undefined || this.address.state === 'undefined') {
      this.statusText7 = 'Please enter state';
    }
    if (this.address.zip == '' || this.address.zip === null || this.address.zip === undefined || this.address.zip === 'undefined') {
      this.statusText8 = 'Please enter zip';
    }
    if (this.statusText1 != "" || this.statusText2 != "" || this.statusText3 != "" || this.statusText4 != "" || this.statusText5 != "" || this.statusText6 != "" || this.statusText7 != "" || this.statusText8 != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    this.addresses.push(this.address);
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createShiftDrivers', {
      "driverName": this.driverName,
      "email": this.email,
      "firstName": this.driverName,
      "lastName": this.driverName,
      "mobileNumber": this.mobileNumber,
      "addresses": this.addresses,
      "organizationId": 1,
      "status": "ACTIVE"
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Driver Details', 'Created Successfully');

          this.router.navigate(['/admin/driversList']);
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }
}
